import store from '../store'

export default function (to, from, next){
    if (store.getters.loggedIn) {
        if(to.name === 'ServicesCard' && store.getters.hasRole('Executor') && !store.getters.hasRole('ClientManager')){
            next({
                name: 'ExecutorServicesCard',
                params: {
                    serviceId: to.params.serviceId
                }
            })
            return
        }
        if(from.name === 'ServicesCard' || from.name === 'ExecutorServicesCard'){
            store.dispatch('leaveGroup')
        }
        if (Object.prototype.hasOwnProperty.call(to.meta, 'role')) {
            if (store.getters.hasRole(to.meta.role)) {
                next()
                return
            } else {
                next('/404')
                return
            }
        }

        next()
    } else {
        next({path: '/login', query: {redirect: to.path}})
    }
}